import Layout from '../components/Layout';
import Contact from '../components/Contact';

export default () => (
  <Layout>
    <div className="container">
      <h2 className="mb-30">Request a demo</h2>
      <div class="calendly-inline-widget" data-url="https://calendly.com/matlogica" style={{ minWidth: '320px', height: '630px' }}></div>
      <Contact/>
    </div>
  </Layout>
)